import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicsShowcase() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">精选专题</h2>
          <p className="mt-1 text-sm text-foreground-500">围绕一个主题，把相关的资讯与观点串成一条完整的线</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((t) => (
          <Link
            key={t.id}
            to={`/topic/${t.id}`}
            className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
          >
            <div className="h-36 w-full overflow-hidden bg-background-200">
              <img
                src={t.cover}
                alt={t.title}
                title={`${t.title} - 噜噜社专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-4">
              <span className="mb-2 inline-flex w-fit rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                专题 · {t.articleIds.length} 篇
              </span>
              <h3 className="text-base font-bold text-foreground-950 transition-colors group-hover:text-accent-600">
                {t.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{t.subtitle}</p>
              <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-500">{t.intro}</p>
              <span className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600">
                进入专题 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}